export default __webpack_public_path__ + "static/media/Poppinspoppins-semiboldmedium.69811052.woff";